export default __webpack_public_path__ + "static/media/scissors.fc80ec9d.png";